(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function setupRevealAnimations() {
    const targets = Array.from(
      document.querySelectorAll(
        ".mc2-doodle-card, .press-pill, .mc2-logo-strip__chip, .mc2-heading, .mc2-subheading, .mc2-proto-slide-text, .mc2-proto-slide-visual"
      )
    );
    if (!targets.length) return;

    targets.forEach((el) => el.classList.add("mc2-reveal"));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("mc2-reveal-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );
    targets.forEach((el) => io.observe(el));
  }

  function setupHoverTilt() {
    const tiltTargets = document.querySelectorAll(
      ".mc2-doodle-card, .mc2-all-treats-grid .product-card-wrapper .card, .press-pill, .mc2-logo-strip__chip"
    );
    if (!tiltTargets.length) return;

    tiltTargets.forEach((el) => {
      el.addEventListener("mousemove", (e) => {
        const rect = el.getBoundingClientRect();
        const px = (e.clientX - rect.left) / rect.width;
        const py = (e.clientY - rect.top) / rect.height;
        const rx = (py - 0.5) * -4;
        const ry = (px - 0.5) * 4;
        el.style.transform = "perspective(700px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg) translateY(-2px)";
      });
      el.addEventListener("mouseleave", () => {
        el.style.transform = "";
      });
    });
  }

  function setupMarqueeHoverPause() {
    document.querySelectorAll(".ticker-track, .press-track").forEach((track) => {
      const parent = track.closest(".ticker-wrap, .press-marquee");
      if (!parent) return;
      parent.addEventListener("mouseenter", () => {
        track.style.animationPlayState = "paused";
      });
      parent.addEventListener("mouseleave", () => {
        track.style.animationPlayState = "running";
      });
    });
  }

  function setupHeaderInk() {
    const list = document.querySelector(".mc2-theme-header .list-menu--inline");
    if (!list) return;
    if (list.querySelector(".mc2-nav-ink")) return;

    const ink = document.createElement("span");
    ink.className = "mc2-nav-ink";
    list.appendChild(ink);

    const items = list.querySelectorAll(".header__menu-item");
    items.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        const r = item.getBoundingClientRect();
        const lr = list.getBoundingClientRect();
        ink.style.left = r.left - lr.left + 10 + "px";
        ink.style.width = Math.max(0, r.width - 20) + "px";
        ink.style.opacity = "1";
      });
    });
    list.addEventListener("mouseleave", () => {
      ink.style.opacity = "0";
    });
  }

  onReady(function () {
    setupRevealAnimations();
    setupHoverTilt();
    setupMarqueeHoverPause();
    setupHeaderInk();
  });
})();
